// leaf-town - bosses: NULL, MERGE CONFLICT, THE LEAK, INFINITE LOOP, THE MONOLITH
(function () {
  'use strict';
  const G = window.G, T = 16, W = G.W, C = G.COL, K = C.ink;
  const FLOOR = 176;                                // every arena shares this floor line

  class Boss extends G.Enemy {
    constructor(L, x, y, w, h, hp) {
      super(L, 0, 0, w, h);
      this.x = x - w / 2; this.y = y - h;
      this.hp = this.maxHp = hp; this.active = false; this.passive = true; this.always = true; this.keep = true;
      this.stompable = false; this.isBoss = true; this.phase = 1; this.st = 'wait'; this.st_t = 0; this.n = 0; this.kb = 0; this.dying = false; this.dieT = 0;
    }
    set(st, t) { this.st = st; this.st_t = t || 0; this.n = 0; }
    start() { this.active = true; this.passive = false; this.set('idle', 1); }
    hit(d, dx, dy, how, box) {
      if (!this.active || this.dying) return false;
      if (box && box.armor) return 'block';
      if (how === 'agent') d *= 0.5;
      if (how === 'dash') d *= 0.5;
      this.hp -= d; this.flash = 0.1;
      this.L.burst(box.x + box.w / 2, box.y + box.h / 2, 6, [this.col, '#fff'], 120, 200, { glow: 1 });
      G.audio.sfx('bossHit');
      if (this.onDamage) this.onDamage(d, box);
      if (this.hp <= 0 && !this.dying) { this.hp = 0; this.beginDeath(); return 'kill'; }
      return 'hit';
    }
    beginDeath() {
      this.dying = true; this.dieT = 0; this.passive = true;
      this.L.projs.forEach((q) => (q.dead = true));
      for (const e of this.L.ents) if (e !== this && !e.isBoss) { e.loot = 0; e.die && e.die(); }
      this.L.stop(0.35); this.L.shake(1); this.L.flashScreen(0.9);
      this.L.events.push('bossDying');
    }
    // generic "blow up for a while" ending; returns true when finished
    deathRattle(dt, dur, cols) {
      this.dieT += dt;
      if (Math.random() < 0.35) { const x = this.x + G.rand(0, this.w), y = this.y + G.rand(0, this.h); this.L.explode(x, y, G.rand(8, 16), cols); G.audio.sfx('explode', { vol: 0.6 }); this.L.shake(0.25); }
      if (this.dieT >= dur && !this.gone) {
        this.gone = true; this.dead = true; this.keep = true;
        this.L.explode(this.cx, this.cy, 46, cols); this.L.flashScreen(1); this.L.shake(1); G.audio.sfx('bigExplode');
        this.L.drop(this.cx, this.cy, 24);
        this.L.events.push('bossDead');
        return true;
      }
      return false;
    }
    warnCol(g, x, cx, cy, t) {         // dashed danger column
      const sx = Math.round(x) - cx;
      g.fillStyle = ((t * 12) | 0) % 2 ? C.hazard : C.hazardHi;
      for (let y = 20 + (((t * 60) | 0) % 8); y < FLOOR - cy; y += 8) g.fillRect(sx, y, 1, 4);
      G.text(G.ug, '!', sx - 1, 20, C.hazardHi, { outline: K });
    }
  }
  G.Boss = Boss;

  // =====================================================================
  // NULL - the null pointer. Points at nothing, hits everything.
  // =====================================================================
  const nullSpr = [0, 1].map((f) => {
    const p = G.pix(44, 54);
    p.ell(22, 17, 15, 15, '#0b0914');
    p.rect(7, 17, 30, 26, '#0b0914');
    for (let i = 0; i < 6; i++) { const x = 7 + i * 5, d = (i + f) % 2 ? 6 : 2; p.rect(x, 43, 5, d, '#0b0914'); }
    const r = G.rng(3 + f);
    for (let i = 0; i < 50; i++) p.px(9 + Math.floor(r() * 26), 8 + Math.floor(r() * 36), r() < 0.5 ? '#1a1f3a' : '#15122a');
    p.outline('#bfe9ff');
    G.ring(p.g, 15, 17, 4, '#ffffff'); G.ring(p.g, 28, 17, 4, '#ffffff');
    G.text(p.g, 'NULL', 22, 31, '#3d5a80', { tiny: true, align: 'c' });
    return p.c;
  });
  const cursorSpr = (() => {
    const rows = ['#', '##', '#.#', '#..#', '#...#', '#....#', '#.....#', '#......#', '#.......#', '#........#', '#.....#####', '#..#..#', '#.#.#..#', '##  #..#', '#    #..#', '     #..#', '      ##'];
    const p = G.pix(13, 19);
    p.rows(1, 1, rows, { '#': '#0b0914', '.': '#ffffff' });
    return p.c;
  })();
  class Null extends Boss {
    constructor(L, x, y) {
      super(L, x, y - 30, 26, 36, 26);
      this.name = 'NULL'; this.sub = 'the null pointer'; this.col = '#bfe9ff';
      this.cur = { x: this.cx - 30, y: this.cy, a: 0, mode: 'orbit', vx: 0, vy: 0 };
      this.cycle = 0; this.tx = this.x; this.ty = this.y; this.marks = []; this.aim = null; this.trail = [];
    }
    onDamage() {
      if (this.phase === 1 && this.hp <= this.maxHp / 2) { this.phase = 2; this.L.events.push('bossPhase'); this.L.shake(0.6); this.L.flashScreen(0.5, '#bfe9ff'); G.audio.sfx('glitch'); this.set('idle', 1.4); this.cur.mode = 'orbit'; this.marks = []; }
    }
    update(dt) {
      this.tick(dt);
      const L = this.L, p = L.player, c = this.cur, fast = this.phase === 2;
      if (this.dying) { this.y += Math.sin(this.t * 40) * 0.6; if (Math.random() < 0.3) G.audio.sfx('glitch', { vol: 0.3 }); this.deathRattle(dt, 2.2, ['#fff', '#bfe9ff', '#3d5a80']); return; }
      if (!this.active) { this.y += Math.sin(this.t * 2) * 0.2; this.orbit(dt); return; }
      this.st_t -= dt;
      const pcx = p.x + 5, pcy = p.y + 5;
      if (this.st === 'idle') {
        const side = pcx < W / 2 ? 1 : -1;
        this.tx = W / 2 + side * 96 - this.w / 2; this.ty = 96 + Math.sin(this.t * 2) * 8;
        if (this.st_t <= 0) {
          const pick = ['poke', 'rain', 'sweep'][this.cycle++ % 3];
          if (pick === 'poke') { this.set('poke', 0); this.n = fast ? 5 : 3; c.mode = 'aim'; c.t = fast ? 0.5 : 0.7; this.pickAim(); }
          else if (pick === 'rain') { this.set('rain', 0.6); this.n = fast ? 4 : 3; }
          else { this.set('sweepPrep', 0.9); this.dir = pcx < W / 2 ? -1 : 1; }
        }
      } else if (this.st === 'poke') {
        this.ty = 70 + Math.sin(this.t * 2) * 6;
        if (c.mode === 'aim') {
          c.t -= dt;
          c.x = G.damp(c.x, this.aimFrom.x, 10, dt); c.y = G.damp(c.y, this.aimFrom.y, 10, dt);
          if (c.t > 0.16) this.aim = { x: pcx, y: pcy };
          c.a = Math.atan2(this.aim.y - c.y, this.aim.x - c.x);
          if (c.t <= 0) { c.mode = 'fly'; c.vx = Math.cos(c.a) * 560; c.vy = Math.sin(c.a) * 560; c.t = 0.7; G.audio.sfx('dash'); }
        } else if (c.mode === 'fly') {
          c.t -= dt; c.x += c.vx * dt; c.y += c.vy * dt;
          this.trail.push({ x: c.x, y: c.y, a: c.a, life: 0.15 });
          if (L.solidAt(c.x, c.y) || c.t <= 0) { c.mode = 'stuck'; c.t = --this.n > 0 ? (fast ? 0.25 : 0.4) : 1.9; L.shake(0.3); L.spark(c.x, c.y, '#fff', 8); G.audio.sfx('thud', { vol: 0.7 }); }
        } else if (c.mode === 'stuck') {
          c.t -= dt;
          if (this.n <= 0) { this.ty = FLOOR - 62; }                // slumps while disarmed
          if (c.t <= 0) { if (this.n > 0) { c.mode = 'aim'; c.t = fast ? 0.45 : 0.62; this.pickAim(); } else { c.mode = 'orbit'; this.set('idle', fast ? 0.7 : 1.1); } }
        }
      } else if (this.st === 'rain') {
        this.tx = W / 2 - this.w / 2; this.ty = 34;
        if (this.st_t <= 0) {
          if (this.n-- > 0) {
            const slots = [...Array(11).keys()].sort(() => Math.random() - 0.5).slice(0, fast ? 7 : 5);
            for (const s of slots) this.marks.push({ x: 32 + s * 32, t: 0.75 });
            this.st_t = fast ? 1.0 : 1.25; G.audio.sfx('warn');
          } else this.set('idle', 1.2);
        }
      } else if (this.st === 'sweepPrep') {
        this.tx = this.dir < 0 ? W - 52 : 24; this.ty = FLOOR - this.h - 2;
        if (this.st_t <= 0) { this.set('sweep', 0); G.audio.sfx('dash'); L.shake(0.2); }
      } else if (this.st === 'sweep') {
        this.x += this.dir * (fast ? 400 : 330) * dt; this.tx = this.x; this.ty = FLOOR - this.h - 2;
        this.trail.push({ x: this.x, y: this.y, body: 1, life: 0.2 });
        if ((this.dir < 0 && this.x < 22) || (this.dir > 0 && this.x > W - 22 - this.w)) { this.set('tired', fast ? 1.0 : 1.5); L.shake(0.4); G.audio.sfx('thud'); L.dust(this.cx, FLOOR, 8); }
      } else if (this.st === 'tired') {
        this.ty = FLOOR - this.h - 6 + Math.sin(this.t * 14) * 1;
        if (this.st_t <= 0) this.set('idle', 0.8);
      }
      if (this.st !== 'sweep') { this.x = G.damp(this.x, this.tx, this.st === 'sweepPrep' ? 5 : 2.2, dt); this.y = G.damp(this.y, this.ty, 3, dt); }
      if (c.mode === 'orbit') this.orbit(dt);
      for (const m of this.marks) { m.t -= dt; if (m.t <= 0 && !m.done) { m.done = true; L.shoot(m.x, 14, 0, 250, { kind: 'shard', col: '#bfe9ff', r: 3, tile: true }); } }
      this.marks = this.marks.filter((m) => !m.done);
      for (const q of this.trail) q.life -= dt;
      this.trail = this.trail.filter((q) => q.life > 0);
    }
    pickAim() {
      const p = this.L.player, a = -Math.PI / 2 + G.rand(-1.1, 1.1);
      this.aimFrom = { x: G.clamp(p.x + 5 + Math.cos(a) * 84, 30, W - 30), y: G.clamp(p.y + Math.sin(a) * 84, 24, 150) };
      this.aim = { x: p.x + 5, y: p.y + 5 };
      G.audio.sfx('warn', { vol: 0.6 });
    }
    orbit(dt) { const c = this.cur; c.x = G.damp(c.x, this.cx + Math.cos(this.t * 1.7) * 30, 6, dt); c.y = G.damp(c.y, this.cy + Math.sin(this.t * 2.3) * 14, 6, dt); c.a = G.damp(c.a, -2.17 + Math.sin(this.t * 2) * 0.2, 6, dt); }
    harmboxes() {
      const b = [{ x: this.x + 3, y: this.y + 3, w: this.w - 6, h: this.h - 6 }];
      if (this.cur.mode === 'fly') b.push({ x: this.cur.x - 5, y: this.cur.y - 5, w: 10, h: 10 });
      return b;
    }
    hurtboxes() { return [{ x: this.x - 2, y: this.y - 4, w: this.w + 4, h: this.h + 8 }]; }
    drawCursor(g, x, y, a, alpha) {
      g.save(); g.globalAlpha = alpha; g.translate(Math.round(x), Math.round(y)); g.rotate(a + 2.17); g.drawImage(cursorSpr, -1, -1); g.restore();
    }
    draw(g, cx, cy) {
      const c = this.cur;
      for (const q of this.trail) {
        if (q.body) { g.globalAlpha = q.life * 2.5; g.drawImage(G.tint(nullSpr[0], '#bfe9ff'), Math.round(q.x) - cx - 9, Math.round(q.y) - cy - 8); g.globalAlpha = 1; }
        else this.drawCursor(g, q.x - cx, q.y - cy, q.a, q.life * 3);
      }
      if (this.dying && ((this.t * 30) | 0) % 3 === 0) return;
      const img = this.flash > 0 ? G.tint(nullSpr[0], '#fff') : nullSpr[((this.t * 5) | 0) % 2];
      const jx = this.st === 'sweepPrep' ? ((this.t * 40) | 0) % 2 : 0;
      g.drawImage(img, Math.round(this.x) - cx - 9 + jx, Math.round(this.y) - cy - 8);
      if (this.phase === 2) { G.ring(g, this.x + 6 - cx + jx, this.y + 9 - cy, 4, C.hazard); G.ring(g, this.x + 19 - cx + jx, this.y + 9 - cy, 4, C.hazard); }
      G.light(this.cx - cx, this.cy - cy, 70, '#bfe9ff', 0.8, 0.22);
      if (c.mode === 'aim' && this.aim) {             // dotted line: where it points is where it lands
        const dx = Math.cos(c.a), dy = Math.sin(c.a);
        for (let i = 14; i < 420; i += 6) { const x = c.x + dx * i, y = c.y + dy * i; if (this.L.solidAt(x, y)) break; g.fillStyle = (((i / 6) | 0) + ((this.t * 20) | 0)) % 2 ? C.hazard : C.hazardHi; g.fillRect(Math.round(x) - cx, Math.round(y) - cy, 2, 2); }
      }
      const shake = c.mode === 'stuck' ? Math.sin(this.t * 70) * 0.06 : 0;
      this.drawCursor(g, c.x - cx, c.y - cy, c.a + shake, 1);
      G.light(c.x - cx, c.y - cy, 26, '#ffffff', 0.7, 0.3);
      for (const m of this.marks) this.warnCol(g, m.x, cx, cy, this.t);
      if (this.st === 'sweepPrep') { g.fillStyle = ((this.t * 14) | 0) % 2 ? C.hazard : C.hazardHi; for (let x = 20; x < W - 20; x += 8) g.fillRect(x - cx, FLOOR - 14 - cy, 4, 1); }
    }
  }

  // =====================================================================
  // MERGE CONFLICT - two heads, one file, zero agreement.
  // =====================================================================
  function headSpr(main, lo, hi, open) {
    const p = G.pix(36, 30);
    p.ell(15, 13, 11, 9, main);
    p.rect(14, 8, 16, 8, main);                         // snout
    p.rect(14, 16 + (open ? 3 : 0), 15, 5, lo);         // jaw
    for (let i = 0; i < 5; i++) { p.px(17 + i * 3, 16, '#fff'); if (open) p.px(17 + i * 3, 18, '#fff'); }
    if (open) p.rect(15, 16, 13, 3, '#2a0f1c');
    p.ell(11, 9, 5, 3, hi);
    p.rect(17, 9, 4, 3, '#fff').rect(19, 10, 2, 2, K).rect(16, 7, 6, 1, K);
    p.rect(4, 3, 3, 4, hi).rect(8, 1, 3, 4, hi);        // horns
    p.px(28, 10, K).px(28, 12, K);
    p.outline(K);
    return p.c;
  }
  const HEADS = [
    { name: '<<<<<<< HEAD', voice: 'head', main: '#4ec9b0', lo: '#23806e', hi: '#b5f5e6', glyph: '<' },
    { name: '>>>>>>> theirs', voice: 'theirs', main: '#e05a8a', lo: '#8c2356', hi: '#ffc2d8', glyph: '>' },
  ];
  HEADS.forEach((h) => { h.spr = [headSpr(h.main, h.lo, h.hi, 0), headSpr(h.main, h.lo, h.hi, 1)]; h.dead = [G.tint(h.spr[0], '#4a4458')]; });
  class Merge extends Boss {
    constructor(L, x, y) {
      super(L, W / 2, 120, 20, 20, 28);
      this.name = 'MERGE CONFLICT'; this.sub = 'both modified: everything'; this.col = '#f4ede0';
      this.heads = [0, 1].map((i) => ({
        i, def: HEADS[i], side: i ? 1 : -1, ax: i ? W - 16 : 16, ay: 76, x: i ? W - 70 : 70, y: 92, rx: i ? W - 78 : 78, ry: 96,
        hp: 14, st: 'rest', t: 0, open: 0, flash: 0, dead: false, vx: 0, vy: 0,
      }));
      this.cycle = 0; this.busy = 0;
    }
    hurtboxes() { return this.heads.filter((h) => !h.dead).map((h) => ({ x: h.x - 14, y: h.y - 12, w: 28, h: 24, head: h })); }
    harmboxes() { return this.heads.filter((h) => !h.dead).map((h) => ({ x: h.x - 11, y: h.y - 9, w: 22, h: 18 })); }
    hit(d, dx, dy, how, box) {
      if (!this.active || this.dying || !box || !box.head) return false;
      const h = box.head;
      if (how === 'agent' || how === 'dash') d *= 0.5;
      h.hp -= d; h.flash = 0.1; this.hp = Math.max(0, this.heads[0].hp) + Math.max(0, this.heads[1].hp);
      this.L.burst(h.x, h.y, 6, [h.def.main, '#fff'], 120, 200, { glow: 1 });
      G.audio.sfx('bossHit');
      if (h.hp <= 0) {
        h.dead = true; h.st = 'dead'; h.vy = -120;
        this.L.explode(h.x, h.y, 22, ['#fff', h.def.hi, h.def.main]); this.L.shake(0.7); this.L.stop(0.2); G.audio.sfx('explode');
        const other = this.heads[1 - h.i];
        if (other.dead) { this.last = h; this.beginDeath(); return 'kill'; }
        this.phase = 2; this.alone = other; this.L.events.push('bossPhase'); this.busy = 1.6;
        return 'kill';
      }
      return 'hit';
    }
    act(h, kind) {
      h.st = kind; h.t = 0; h.n = 0;
      if (kind === 'lunge') { G.audio.sfx('warn'); }
      if (kind === 'spit') { G.audio.sfx('charge', { vol: 0.5 }); }
    }
    update(dt) {
      this.tick(dt);
      const L = this.L, p = L.player, pcx = p.x + 5, pcy = p.y + 5, rage = this.phase === 2;
      if (this.dying) {
        this.dieT += dt;
        if (Math.random() < 0.3) { const h = G.pick(this.heads); L.explode(h.x + G.rand(-14, 14), h.y + G.rand(-10, 10), G.rand(8, 14), ['#fff', '#4ec9b0', '#e05a8a']); G.audio.sfx('explode', { vol: 0.5 }); }
        if (this.dieT > 2.2 && !this.gone) { this.gone = true; this.dead = true; L.flashScreen(1); L.shake(1); G.audio.sfx('bigExplode'); for (const h of this.heads) L.explode(h.x, h.y, 34, ['#fff', h.def.hi, h.def.main]); L.drop(W / 2, 100, 24); L.events.push('bossDead'); }
        for (const h of this.heads) { h.vy += 500 * dt; h.y = Math.min(FLOOR - 10, h.y + h.vy * dt); }
        return;
      }
      for (const h of this.heads) {
        if (h.flash > 0) h.flash -= dt;
        h.t += dt;
        const bob = Math.sin(this.t * 2 + h.i * 2) * 7;
        if (h.dead) { h.vy += 500 * dt; h.y = Math.min(FLOOR - 10, h.y + h.vy * dt); continue; }
        if (!this.active || h.st === 'rest') { h.x = G.damp(h.x, h.rx, 3, dt); h.y = G.damp(h.y, h.ry + bob, 3, dt); h.open = 0; continue; }
        if (h.st === 'lunge') {
          const tele = rage ? 0.5 : 0.75;
          if (h.t < tele) {                                 // pull back, open wide, lock on
            h.x = G.damp(h.x, h.ax - h.side * 34, 6, dt); h.y = G.damp(h.y, 70, 6, dt); h.open = 1;
            if (h.t < tele - 0.18) h.aim = { x: G.clamp(pcx, 30, W - 30), y: G.clamp(pcy, 40, FLOOR - 10) };
          } else if (!h.n) {
            const dx = h.aim.x - h.x, dy = h.aim.y - h.y, d = Math.hypot(dx, dy) || 1;
            if (h.n === 0 && !h.launched) { h.launched = true; G.audio.sfx('dash'); }
            const s = 460 * dt;
            if (d <= s) { h.x = h.aim.x; h.y = h.aim.y; h.n = 1; h.t2 = rage ? 1.0 : 1.4; h.launched = false; L.shake(0.35); G.audio.sfx('thud'); if (h.y > FLOOR - 24) L.dust(h.x, FLOOR, 8); }
            else { h.x += (dx / d) * s; h.y += (dy / d) * s; }
          } else { h.open = 0; h.t2 -= dt; if (h.t2 <= 0) h.st = 'rest'; }
        } else if (h.st === 'spit') {
          h.x = G.damp(h.x, h.rx, 4, dt); h.y = G.damp(h.y, 58, 4, dt); h.open = h.t > 0.35 ? 1 : 0;
          if (h.t > 0.6 && !h.n) {
            h.n = 1;
            const count = rage ? 7 : 5;
            for (let i = 0; i < count; i++) {
              const u = i / (count - 1), plus = i % 2 === 0;
              L.shoot(h.x - h.side * 12, h.y + 4, -h.side * G.lerp(40, 250, u) + G.rand(-10, 10), G.lerp(-210, -90, u), { kind: plus ? 'plus' : 'minus', col: plus ? '#7fd08a' : '#ff5d5d', g: 330, r: 3 });
            }
            G.audio.sfx('shoot');
          }
          if (h.t > 1.2) h.st = 'rest';
        } else if (h.st === 'slam') {
          const tx = h.rx - h.side * 8;
          if (h.t < 0.7) { h.x = G.damp(h.x, tx, 5, dt); h.y = G.damp(h.y, 44, 5, dt); h.open = 1; }
          else if (!h.n) {
            h.y += 520 * dt;
            if (h.y >= FLOOR - 11) {
              h.y = FLOOR - 11; h.n = 1; h.t2 = rage ? 1.0 : 1.5; L.shake(0.6); G.audio.sfx('thud'); L.dust(h.x, FLOOR, 10);
              for (const d of [-1, 1]) L.shoot(h.x + d * 12, FLOOR - 1, d * 150, 0, { kind: 'wave', col: h.def.main, r: 4, hgt: 11, tile: false, life: 2.2, cut: false });
            }
          } else { h.open = 0; h.t2 -= dt; if (h.t2 <= 0) h.st = 'rest'; }
        }
      }
      if (!this.active) return;
      // conductor
      this.busy -= dt;
      const alive = this.heads.filter((h) => !h.dead);
      if (this.busy <= 0 && alive.every((h) => h.st === 'rest')) {
        const step = this.cycle++;
        if (alive.length === 2) {
          const a = this.heads[step % 2 === 0 ? 0 : 1], b = this.heads[1 - a.i], k = step % 5;
          if (k === 0 || k === 2) { this.act(a, 'lunge'); this.busy = 0.9; }
          else if (k === 1 || k === 3) { this.act(a, 'spit'); this.busy = 0.6; }
          else { this.act(a, 'slam'); this.act(b, 'slam'); this.busy = 1.2; }
        } else {
          const h = alive[0], k = step % 4;
          this.act(h, k === 0 ? 'lunge' : k === 1 ? 'spit' : k === 2 ? 'lunge' : 'slam'); this.busy = 0.5;
        }
      }
    }
    draw(g, cx, cy) {
      // the file they are fighting over
      for (const h of this.heads) {
        const n = 11, mx = (h.ax + h.x) / 2, my = Math.max(h.ay, h.y) + (h.dead ? 6 : 16);
        for (let i = 0; i <= n; i++) {
          const u = i / n, x = (1 - u) * (1 - u) * h.ax + 2 * u * (1 - u) * mx + u * u * h.x, y = (1 - u) * (1 - u) * h.ay + 2 * u * (1 - u) * my + u * u * h.y;
          G.text(g, h.def.glyph, Math.round(x) - cx - 3, Math.round(y) - cy - 9, h.dead ? '#4a4458' : i % 2 ? h.def.main : h.def.lo, { outline: K, scale: 2 });
        }
        if (h.st === 'lunge' && h.aim && !h.n && h.t < 0.8 && !h.dead) {
          for (let i = 0; i < 1; i += 0.06) { const x = G.lerp(h.x, h.aim.x, i), y = G.lerp(h.y, h.aim.y, i); g.fillStyle = ((i * 16 + this.t * 20) | 0) % 2 ? C.hazard : C.hazardHi; g.fillRect(Math.round(x) - cx, Math.round(y) - cy, 2, 2); }
          G.ring(g, h.aim.x - cx, h.aim.y - cy, 6 + Math.sin(this.t * 20) * 2, C.hazard);
        }
        let img = h.dead ? h.def.dead[0] : h.def.spr[h.open ? 1 : 0];
        if (h.flash > 0) img = G.tint(img, '#fff');
        if (this.dying && ((this.t * 30) | 0) % 3 === 0) continue;
        const jit = this.phase === 2 && !h.dead ? Math.round(Math.sin(this.t * 50)) : 0;
        g.save(); g.translate(Math.round(h.x) - cx + jit, Math.round(h.y) - cy); if (h.side > 0) g.scale(-1, 1); g.drawImage(img, -16, -15); g.restore();
        if (!h.dead) G.light(h.x - cx, h.y - cy, 50, h.def.main, 0.8, 0.22);
      }
    }
  }

  // =====================================================================
  // THE LEAK - allocates. never frees.
  // =====================================================================
  const leakSpr = [0, 1].map((f) => {
    const p = G.pix(60, 46);
    p.ell(30, 26 - (f ? 0 : 1), 26 + (f ? 1 : 0), 19 - (f ? 1 : 0), '#58f0c8');
    p.clear(0, 44, 60, 2);
    p.ell(30, 30, 20, 11, '#3fd1b0');
    p.ell(20, 14, 9, 4, '#d2fff2');
    p.ell(30, 28, 8, 7, '#127a80'); p.ell(30, 28, 5, 4, '#0b4d5c'); p.ell(28, 26, 2, 1.5, '#9cf7e0');   // the core
    p.rect(17, 19, 5, 6, K).rect(38, 19, 5, 6, K).rect(18, 20, 2, 2, '#fff').rect(39, 20, 2, 2, '#fff');
    p.rect(10, 40, 3, 4, '#58f0c8').rect(45, 41, 3, 3, '#58f0c8');
    p.outline('#0c4f58');
    return p.c;
  });
  class Leak extends Boss {
    constructor(L, x, y) {
      super(L, x, y, 44, 32, 34);
      this.name = 'THE LEAK'; this.sub = 'malloc() without free()'; this.col = '#58f0c8';
      this.cycle = 0; this.sq = 1; this.level = 0; this.floodY = FLOOR + 40; this.marks = []; this.geyser = null;
      L.liquidY = this.floodY;
    }
    get scale() { return 0.62 + 0.38 * (this.hp / this.maxHp); }
    hurtboxes() { const s = this.scale, w = 46 * s, h = 34 * s; return [{ x: this.cx - w / 2, y: this.y + this.h - h, w, h }]; }
    harmboxes() { const s = this.scale, w = 38 * s, h = 28 * s; const b = [{ x: this.cx - w / 2, y: this.y + this.h - h, w, h }]; if (this.geyser && this.geyser.on) b.push({ x: this.geyser.x - 9, y: this.geyser.top, w: 18, h: 300 }); return b; }
    onDamage() {
      const f = this.hp / this.maxHp, want = f <= 0.34 ? 2 : f <= 0.67 ? 1 : 0;
      this.sq = 1.25;
      if (want > this.level) {
        this.level = want; this.phase = want + 1; this.L.events.push(want === 1 ? 'bossPhase' : 'bossPhase3');
        this.L.shake(0.8); G.audio.sfx('roar'); this.set('flood', 1.6); this.vx = 0; this.vy = -200;
      }
    }
    update(dt) {
      this.tick(dt);
      const L = this.L, p = L.player, pcx = p.x + 5;
      this.sq = G.damp(this.sq, 1, 8, dt);
      // the tide
      const targetY = this.level === 0 ? FLOOR + 40 : this.level === 1 ? FLOOR - 14 : FLOOR - 60;
      this.floodY = G.approach(this.floodY, targetY, 26 * dt);
      L.liquidY = this.floodY;
      if (this.dying) { this.level = -1; this.floodY = G.approach(this.floodY, FLOOR + 60, 60 * dt); L.liquidY = this.floodY; this.sq = 1 + Math.sin(this.t * 30) * 0.1; this.deathRattle(dt, 2.2, ['#fff', '#d2fff2', '#58f0c8', '#127a80']); return; }
      if (!this.active) return;
      this.st_t -= dt;
      const afloat = this.level > 0 && this.floodY < FLOOR - 4;
      for (const m of this.marks) { m.t -= dt; if (m.t <= 0 && !m.done) { m.done = true; L.shoot(m.x, 18, 0, 60, { kind: 'drip', col: '#58f0c8', g: 480, r: 3, cut: false }); } }
      this.marks = this.marks.filter((m) => !m.done);
      if (this.geyser) {
        const q = this.geyser; q.t -= dt;
        if (!q.on && q.t <= 0) { q.on = true; q.t = 0.7; q.top = this.floodY - 120; G.audio.sfx('splash'); L.shake(0.3); }
        else if (q.on && q.t <= 0) this.geyser = null;
        else if (q.on) for (let i = 0; i < 3; i++) L.part(q.x + G.rand(-7, 7), this.floodY, G.rand(-20, 20), G.rand(-380, -220), 0.35, 2 + (Math.random() * 2 | 0), G.pick(['#58f0c8', '#d2fff2', '#3fd1b0']), 600);
        else if (Math.random() < 0.5) L.part(q.x + G.rand(-8, 8), this.floodY, 0, G.rand(-50, -20), 0.3, 1, '#d2fff2', 0);
      }
      if (afloat) {
        // wading in its own mess
        this.y = G.damp(this.y, this.floodY - this.h * 0.62 + Math.sin(this.t * 2.2) * 2, 4, dt);
        if (this.st !== 'flood') this.x = G.clamp(this.x + G.clamp(pcx - this.cx, -1, 1) * (this.level === 2 ? 34 : 24) * dt, 40, W - 40 - this.w);
        if (this.st_t <= 0) {
          const k = this.cycle++ % 3;
          if (k === 0) { this.lob(this.level === 2 ? 4 : 3); this.set('wait', 1.7); }
          else if (k === 1) { this.geyser = { x: G.clamp(pcx, 40, W - 40), t: 0.9, on: false }; G.audio.sfx('warn'); this.set('wait', 2.2); }
          else { this.spawn(2); this.rain(this.level === 2 ? 5 : 3); this.set('wait', 2.2); }
        }
        return;
      }
      if (this.st === 'idle' || this.st === 'wait' || this.st === 'flood') {
        this.vx *= 0.85;
        if (this.st_t <= 0 && this.onGround) {
          const k = this.cycle++ % 3;
          if (k === 0) { this.set('hop', 0.2); this.n = 3; }
          else if (k === 1) { this.spawn(3); this.set('wait', 1.6); }
          else { this.rain(4); this.set('wait', 1.5); }
        }
      } else if (this.st === 'hop') {
        if (this.onGround && this.st_t <= 0) {
          if (this.n-- > 0) { this.vy = -285; this.vx = G.clamp((pcx - this.cx) * 1.4, -120, 120); this.onGround = false; this.sq = 0.8; G.audio.sfx('jump', { vol: 0.6 }); }
          else this.set('wait', 1.3);
        }
      }
      const landed = this.physics(dt, 760);
      this.x = G.clamp(this.x, 18, W - 18 - this.w);
      if (landed) {
        this.sq = 1.35; this.vx = 0; this.st_t = Math.max(this.st_t, 0.45); L.shake(0.5); G.audio.sfx('thud'); L.dust(this.cx, FLOOR, 10);
        L.burst(this.cx, FLOOR - 4, 10, ['#58f0c8', '#d2fff2'], 110, 320);
        if (this.st === 'hop') for (const d of [-1, 1]) L.shoot(this.cx + d * 20, FLOOR - 1, d * 125, 0, { kind: 'wave', col: '#58f0c8', r: 4, hgt: 9, tile: false, life: 1.1, cut: false });
      }
    }
    lob(n) {
      const p = this.L.player;
      for (let i = 0; i < n; i++) {
        const tx = p.x + 5 + (i - (n - 1) / 2) * 34, t = 0.95, g = 420;
        this.L.shoot(this.cx, this.y, (tx - this.cx) / t, (p.y - this.y) / t - 0.5 * g * t, { kind: 'orb', col: '#58f0c8', g, r: 4, tile: true, life: 3 });
      }
      this.sq = 0.8; G.audio.sfx('shoot');
    }
    spawn(n) {
      const L = this.L, alive = L.ents.filter((e) => e instanceof G.Enemies.Slime && !e.dead).length;
      for (let i = 0; i < Math.min(n, 4 - alive); i++) {
        const s = new G.Enemies.Slime(L, this.cx - 4, this.y - 8, true);
        s.x = this.cx - 4; s.y = this.y - 6; s.vx = G.rand(-150, 150); s.vy = G.rand(-300, -220); s.loot = 0; s.wait = 0.8;
        L.ents.push(s);
      }
      this.sq = 0.75; G.audio.sfx('splash', { vol: 0.7 });
    }
    rain(n) { const p = this.L.player; for (let i = 0; i < n; i++) this.marks.push({ x: G.clamp(p.x + 5 + G.rand(-90, 90), 26, W - 26), t: 0.7 + i * 0.22 }); G.audio.sfx('warn', { vol: 0.6 }); }
    draw(g, cx, cy) {
      const s = this.scale;
      let img = leakSpr[((this.t * 3) | 0) % 2];
      if (this.flash > 0) img = G.tint(img, '#fff');
      if (!(this.dying && ((this.t * 30) | 0) % 3 === 0)) G.spr(g, img, Math.round(this.cx) - cx, Math.round(this.y + this.h) - cy + 2, false, s * this.sq, s * (2 - this.sq));
      G.light(this.cx - cx, this.cy - cy, 80, '#58f0c8', 0.9, 0.25);
      for (const m of this.marks) { const x = Math.round(m.x) - cx; g.fillStyle = '#58f0c8'; const sz = Math.ceil((1 - Math.min(1, m.t / 0.7)) * 4); g.fillRect(x - 1, 10 - cy, 2, 2 + sz); g.fillRect(x - 2, 10 + sz - cy, 4, 2); }
      if (this.geyser) {
        const q = this.geyser, x = Math.round(q.x) - cx;
        if (q.on) { g.fillStyle = G.rgba('#58f0c8', 0.75); g.fillRect(x - 8, q.top - cy, 16, this.floodY - q.top); g.fillStyle = '#d2fff2'; g.fillRect(x - 3, q.top - cy + 3, 5, this.floodY - q.top); G.light(x, this.floodY - 60 - cy, 70, '#58f0c8', 1, 0.4); }
        else { g.fillStyle = ((this.t * 14) | 0) % 2 ? C.hazard : C.hazardHi; for (let y = this.floodY - 120; y < this.floodY; y += 8) g.fillRect(x, y - cy, 1, 4); }
      }
    }
  }

  // =====================================================================
  // INFINITE LOOP - while (true) { }
  // =====================================================================
  const loopSpr = (() => {
    const head = G.pix(26, 24);
    head.ell(12, 12, 10, 9, '#d9ab5c'); head.rect(12, 6, 11, 6, '#d9ab5c'); head.rect(12, 14, 10, 4, '#8f6430');
    head.ell(9, 8, 4, 2.5, '#fff0c0');
    for (let i = 0; i < 4; i++) head.px(14 + i * 2, 13, '#fff');
    head.rect(13, 8, 4, 3, '#fff').rect(15, 9, 2, 2, C.hazard); head.rect(12, 6, 6, 1, K);
    head.rect(3, 2, 2, 4, '#fff0c0').rect(7, 1, 2, 4, '#fff0c0');
    head.outline(K);
    const seg = [0, 1].map((f) => { const p = G.pix(16, 16); p.ell(8, 8, 6, 6, f ? '#c2924a' : '#d9ab5c'); p.ell(8, 8, 3, 3, '#5f3d1e'); p.ell(6.5, 6, 2.2, 1.4, '#fff0c0'); p.outline(K); return p.c; });
    const tail = G.pix(20, 20); tail.ell(10, 10, 7, 7, C.hazard); tail.ell(10, 10, 4, 4, '#ffd0d6'); tail.ell(8.5, 8.5, 1.6, 1.6, '#fff'); tail.outline(K);
    return { head: head.c, seg, tail: tail.c };
  })();
  class Loop extends Boss {
    constructor(L, x, y) {
      super(L, W / 2, 80, 18, 18, 24);
      this.name = 'INFINITE LOOP'; this.sub = 'while (true) { }'; this.col = '#f3d58a'; this.dashable = false;
      this.N = 15; this.hist = []; this.u = 0; this.path = 'coil'; this.cycle = 0; this.hx = W / 2; this.hy = 70; this.ang = 0; this.speedK = 1; this.tailFlash = 0;
      for (let i = 0; i < this.N * 4 + 4; i++) this.hist.push({ x: this.hx - i * 2.2, y: this.hy });
      this.st = 'coil'; this.st_t = 2;
    }
    segPos(i) { return this.hist[Math.min(this.hist.length - 1, (i + 1) * 4)]; }
    hurtboxes() {
      const b = [], t = this.segPos(this.N - 1);
      b.push({ x: t.x - 9, y: t.y - 9, w: 18, h: 18, tail: 1 });
      for (let i = 0; i < this.N - 1; i += 2) { const s = this.segPos(i); b.push({ x: s.x - 5, y: s.y - 5, w: 10, h: 10, armor: 1 }); }
      b.push({ x: this.hx - 8, y: this.hy - 8, w: 16, h: 16, armor: 1 });
      return b;
    }
    harmboxes() {
      const b = [{ x: this.hx - 7, y: this.hy - 7, w: 14, h: 14 }];
      for (let i = 0; i < this.N - 2; i++) { const s = this.segPos(i); b.push({ x: s.x - 4, y: s.y - 4, w: 8, h: 8 }); }
      return b;
    }
    onDamage() {
      this.tailFlash = 0.15;
      if (this.phase === 1 && this.hp <= this.maxHp / 2) { this.phase = 2; this.speedK = 1.28; this.L.events.push('bossPhase'); this.L.shake(0.6); G.audio.sfx('roar'); }
    }
    target(dt) {
      const cx = W / 2, cy = 100, k = this.speedK;
      if (this.path === 'circle') { this.u += dt * 1.45 * k; return [cx + Math.cos(this.u) * 138, cy + Math.sin(this.u) * 62]; }
      if (this.path === 'eight') { this.u += dt * 1.25 * k; return [cx + Math.sin(this.u) * 146, cy + Math.sin(this.u * 2) * 54]; }
      if (this.path === 'dive') { this.u += dt * 0.62 * k; const v = this.u % 2, d = v < 1 ? 1 : -1, w = v < 1 ? v : v - 1; return [d > 0 ? -60 + w * (W + 120) : W + 60 - w * (W + 120), 136 + Math.sin(w * Math.PI * 4) * 30]; }
      this.u += dt * 2.2; return [cx + Math.cos(this.u) * 50, 92 + Math.sin(this.u) * 24];
    }
    update(dt) {
      this.tick(dt);
      const L = this.L, p = L.player;
      if (this.tailFlash > 0) this.tailFlash -= dt;
      if (this.dying) {
        this.dieT += dt;
        const k = Math.floor(this.dieT / 0.14);
        if (k !== this.lastK && k < this.N) { this.lastK = k; const s = this.segPos(this.N - 1 - k); L.explode(s.x, s.y, 12, ['#fff', '#f3d58a', '#c2924a']); G.audio.sfx('explode', { vol: 0.6 }); L.shake(0.3); this.popped = k + 1; }
        if (this.dieT > this.N * 0.14 + 0.6 && !this.gone) { this.gone = true; this.dead = true; L.explode(this.hx, this.hy, 40, ['#fff', '#f3d58a', '#ff7a59']); L.flashScreen(1); L.shake(1); G.audio.sfx('bigExplode'); L.drop(this.hx, this.hy, 24); L.events.push('bossDead'); }
        return;
      }
      if (!this.active) { this.path = 'coil'; }
      else {
        this.st_t -= dt;
        if (this.st_t <= 0) {
          if (this.path === 'coil') { this.path = ['circle', 'eight', 'dive'][this.cycle++ % 3]; this.u = this.path === 'dive' ? 0 : this.path === 'circle' ? -Math.PI / 2 : 0; this.st_t = this.path === 'dive' ? 6.4 / this.speedK : 8.5 / this.speedK; G.audio.sfx('charge'); }
          else { this.path = 'coil'; this.st_t = this.phase === 2 ? 2.3 : 3; this.spat = false; }
        }
        if (this.path === 'coil' && this.phase === 2 && !this.spat && this.st_t < 1.6) {
          this.spat = true;
          for (let i = -1; i <= 1; i++) { const a = Math.atan2(p.y - this.hy, p.x - this.hx) + i * 0.35; L.shoot(this.hx, this.hy, Math.cos(a) * 130, Math.sin(a) * 130, { kind: 'orb', col: '#ff7a59', r: 3 }); }
          G.audio.sfx('shoot');
        }
      }
      const [tx, ty] = this.target(dt);
      const dx = tx - this.hx, dy = ty - this.hy, d = Math.hypot(dx, dy), maxS = (this.path === 'coil' ? 170 : 300) * this.speedK * dt;
      if (d > 0.01) { const s = Math.min(d, maxS); this.hx += (dx / d) * s; this.hy += (dy / d) * s; this.ang = Math.atan2(dy, dx); }
      const h0 = this.hist[0];
      if (G.dist(h0.x, h0.y, this.hx, this.hy) >= 2.2) { this.hist.unshift({ x: this.hx, y: this.hy }); this.hist.pop(); }
      this.x = this.hx - 9; this.y = this.hy - 9;
      if (this.phase === 2 && Math.random() < 0.3) { const s = this.segPos((Math.random() * this.N) | 0); L.part(s.x, s.y, G.rand(-20, 20), G.rand(-20, 20), 0.3, 1, '#ffe27a', 0, { glow: 1 }); }
    }
    draw(g, cx, cy) {
      const n = this.N - (this.popped || 0);
      for (let i = n - 1; i >= 0; i--) {
        const s = this.segPos(i), x = Math.round(s.x) - cx, y = Math.round(s.y) - cy;
        if (i === this.N - 1) {
          const pulse = 1 + Math.sin(this.t * 8) * 0.12;
          G.spr(g, this.tailFlash > 0 ? G.tint(loopSpr.tail, '#fff') : loopSpr.tail, x, y + 10, false, pulse, pulse);
          G.light(x, y, 44, C.hazard, 0.9, 0.4);
          G.text(G.ug, 'break;', x, y - 19, C.hazardHi, { tiny: true, align: 'c', outline: K });
        } else g.drawImage(this.flash > 0 ? G.tint(loopSpr.seg[i % 2], '#fff') : loopSpr.seg[i % 2], x - 8, y - 8);
      }
      if (this.gone) return;
      const flip = Math.cos(this.ang) < 0;
      g.save(); g.translate(Math.round(this.hx) - cx, Math.round(this.hy) - cy); g.rotate(flip ? this.ang + Math.PI : this.ang); if (flip) g.scale(-1, 1);
      g.drawImage(this.flash > 0 ? G.tint(loopSpr.head, '#fff') : loopSpr.head, -12, -12); g.restore();
      G.light(this.hx - cx, this.hy - cy, 50, '#f3d58a', 0.8, 0.2);
    }
  }

  // =====================================================================
  // THE MONOLITH - 400,000 lines. No tests. It works. Nobody knows why.
  // =====================================================================
  const monoSpr = (() => {
    const p = G.pix(74, 170), r = G.rng(1987);
    p.rect(4, 6, 66, 164, '#15171c').rect(4, 6, 66, 2, '#3a3f4c').rect(4, 6, 2, 164, '#2a2e38').rect(68, 6, 2, 164, '#08090c');
    p.rect(10, 0, 50, 6, '#15171c').rect(10, 0, 50, 1, '#3a3f4c');
    const words = ['GOTO', 'PERFORM', 'MOVE', 'IF', 'END', '0010', '0020', 'COMMON', 'JMP', 'XX', 'DATA', 'CALL', 'TODO'];
    for (let y = 14; y < 164; y += 7) {
      let x = 9;
      while (x < 60) { const w = G.pick(words.slice(0, 12)); const wd = G.textW(w, { tiny: true }); if (x + wd > 66) break; if (r() < 0.75) G.text(p.g, w, x, y, r() < 0.12 ? '#3cff7a' : r() < 0.5 ? '#1f7a3a' : '#134a24', { tiny: true }); x += wd + 3 + Math.floor(r() * 4); }
    }
    // the socket where the eye sits
    G.disc(p.g, 37, 62, 19, '#08090c'); G.ring(p.g, 37, 62, 19, '#3a3f4c'); G.ring(p.g, 37, 62, 18, '#2a2e38');
    // forty years of sticky notes
    const note = (x, y, col, txt) => { p.rect(x, y, 15, 11, col).rect(x, y, 15, 2, G.mix(col, '#000000', 0.2)); G.text(p.g, txt, x + 2, y + 4, '#3a2a1a', { tiny: true }); };
    note(8, 96, '#f2e27a', 'TODO'); note(47, 106, '#ff9db5', 'FIX'); note(12, 126, '#9be3a8', 'XXX'); note(44, 140, '#f2e27a', '???');
    p.rect(6, 28, 5, 3, '#ff4b3e').rect(62, 34, 5, 3, '#ff4b3e');   // beam ports are drawn live
    p.outline(K);
    return p.c;
  })();
  const fistSpr = (() => {
    const p = G.pix(28, 26);
    p.rect(2, 4, 24, 18, '#2a2e38').rect(2, 4, 24, 2, '#5c6378').rect(2, 20, 24, 2, '#15171c');
    for (let i = 0; i < 4; i++) p.rect(3 + i * 6, 8, 5, 6, '#3a3f4c').rect(3 + i * 6, 8, 5, 1, '#7d8296');
    G.text(p.g, 'GOTO', 14, 15, '#1f7a3a', { tiny: true, align: 'c' });
    p.outline(K);
    return p.c;
  })();
  class Monolith extends Boss {
    constructor(L, x, y) {
      super(L, 338, FLOOR, 60, 150, 44);
      this.name = 'THE MONOLITH'; this.sub = 'legacy.c • last modified 1987'; this.col = '#3cff7a';
      this.ex = this.x - 2 + 37; this.ey = this.y - 20 + 62; this.open = 0; this.openT = 0; this.cycle = 0; this.dashable = false;
      this.fists = [{ x: 110, y: 46, hx: 110, hy: 46, st: 'idle', t: 0 }, { x: 236, y: 52, hx: 236, hy: 52, st: 'idle', t: 0 }];
      this.beam = null; this.marks = []; this.look = { x: 0, y: 0 }; this.crack = 0;
    }
    start() { super.start(); this.set('idle', 1.4); }
    hurtboxes() { return [{ x: this.ex - 27, y: this.ey - 18, w: 45, h: 36, armor: this.open < 0.5 ? 1 : 0 }]; }
    harmboxes() {
      const b = [{ x: this.x + 12, y: this.y, w: this.w, h: this.h }];
      for (const f of this.fists) if (f.st === 'drop' || f.st === 'sweep' || f.st === 'rest') b.push({ x: f.x - 11, y: f.y - 10, w: 22, h: 20 });
      if (this.beam && this.beam.on) b.push({ x: 16, y: this.beam.y - 4, w: this.x - 10, h: 8 });
      return b;
    }
    onDamage() {
      const f = this.hp / this.maxHp;
      if (this.phase === 1 && f <= 0.62) { this.phase = 2; this.L.events.push('bossPhase'); this.L.shake(0.8); G.audio.sfx('roar'); this.set('idle', 1.6); this.crack = 1; }
      else if (this.phase === 2 && f <= 0.3) { this.phase = 3; this.L.events.push('bossPhase3'); this.L.shake(1); this.L.flashScreen(0.8); G.audio.sfx('roar'); this.set('idle', 1.8); this.crack = 2; }
    }
    slam(i, delay) { const f = this.fists[i]; f.st = 'track'; f.t = (this.phase === 3 ? 0.65 : 0.95) + (delay || 0); G.audio.sfx('warn', { vol: 0.6 }); }
    sweep(i) { const f = this.fists[i]; f.st = 'sweepPrep'; f.t = 0.9; G.audio.sfx('warn'); }
    bolts(n) { this.openT = 2.6; this.boltN = n; this.boltT = 0.5; }
    laser(low) { this.beam = { y: low ? FLOOR - 7 : FLOOR - 52, t: this.phase === 3 ? 0.8 : 1.0, on: false }; this.openT = 3; G.audio.sfx('charge'); }
    update(dt) {
      this.tick(dt);
      const L = this.L, p = L.player, pcx = p.x + 5, pcy = p.y + 5;
      if (this.dying) { this.open = 1; this.beam = null; for (const f of this.fists) { f.y += 200 * dt; } this.deathRattle(dt, 3.4, ['#fff', '#3cff7a', '#ffe27a', '#ff7a2f']); return; }
      this.look.x = G.damp(this.look.x, G.clamp((pcx - this.ex) / 40, -4, 4), 6, dt); this.look.y = G.damp(this.look.y, G.clamp((pcy - this.ey) / 30, -3, 3), 6, dt);
      if (this.phase === 3) this.openT = 1;
      this.openT -= dt; this.open = G.damp(this.open, this.openT > 0 ? 1 : 0, 10, dt);
      // fists
      for (const f of this.fists) {
        f.t -= dt;
        if (f.st === 'idle') { f.x = G.damp(f.x, f.hx, 3, dt); f.y = G.damp(f.y, f.hy + Math.sin(this.t * 2 + f.hx) * 5, 3, dt); }
        else if (f.st === 'track') { f.x = G.damp(f.x, G.clamp(pcx, 30, 280), 7, dt); f.y = G.damp(f.y, 40, 6, dt); if (f.t <= 0) { f.st = 'hang'; f.t = 0.24; } }
        else if (f.st === 'hang') { f.x += Math.sin(this.t * 80) * 0.6; if (f.t <= 0) { f.st = 'drop'; G.audio.sfx('dash', { vol: 0.6 }); } }
        else if (f.st === 'drop') {
          f.y += 620 * dt;
          if (f.y >= FLOOR - 10 || L.solidAt(f.x, f.y + 11)) {
            f.y = Math.min(f.y, FLOOR - 10); f.st = 'rest'; f.t = this.phase === 3 ? 0.55 : 0.9; L.shake(0.6); G.audio.sfx('thud'); L.dust(f.x, FLOOR, 10);
            if (this.phase > 1) for (const d of [-1, 1]) L.shoot(f.x + d * 12, FLOOR - 1, d * 140, 0, { kind: 'wave', col: '#3cff7a', r: 4, hgt: 9, tile: false, life: 1.0, cut: false });
          }
        } else if (f.st === 'rest') { if (f.t <= 0) f.st = 'idle'; }
        else if (f.st === 'sweepPrep') { f.x = G.damp(f.x, 34, 6, dt); f.y = G.damp(f.y, FLOOR - 12, 6, dt); if (f.t <= 0) { f.st = 'sweep'; G.audio.sfx('dash'); } }
        else if (f.st === 'sweep') { f.x += (this.phase === 3 ? 300 : 250) * dt; if (Math.random() < 0.6) L.dust(f.x - 10, FLOOR, 1, -1); if (f.x > 286) { f.st = 'rest'; f.t = 0.5; L.shake(0.4); G.audio.sfx('thud'); } }
      }
      // bolts from the eye
      if (this.boltN > 0) {
        this.boltT -= dt;
        if (this.boltT <= 0) {
          this.boltN--; this.boltT = this.phase === 3 ? 0.28 : 0.42;
          const a = Math.atan2(pcy - this.ey, pcx - (this.ex - 14));
          L.shoot(this.ex - 16, this.ey, Math.cos(a) * 165, Math.sin(a) * 165, { kind: 'bolt', col: '#3cff7a', r: 3 });
          G.audio.sfx('shoot');
        }
      }
      if (this.beam) {
        const b = this.beam; b.t -= dt;
        if (!b.on && b.t <= 0) { b.on = true; b.t = 0.75; G.audio.sfx('laser'); L.shake(0.4); }
        else if (b.on && b.t <= 0) this.beam = null;
      }
      for (const m of this.marks) { m.t -= dt; if (m.t <= 0 && !m.done) { m.done = true; L.shoot(m.x, 14, 0, 240, { kind: 'shard', col: '#3cff7a', r: 3, tile: true }); } }
      this.marks = this.marks.filter((m) => !m.done);
      if (!this.active) return;
      // conductor
      this.st_t -= dt;
      const free = this.fists.every((f) => f.st === 'idle') && !this.beam && !(this.boltN > 0);
      if (this.st_t <= 0 && free) {
        const k = this.cycle++;
        if (this.phase === 1) {
          const s = k % 3;
          if (s === 0) { this.slam(0); this.st_t = 2.2; } else if (s === 1) { this.slam(1); this.st_t = 2.2; } else { this.bolts(3); this.st_t = 3.2; }
        } else if (this.phase === 2) {
          const s = k % 5;
          if (s === 0) { this.slam(0); this.slam(1, 0.5); this.st_t = 2.6; }
          else if (s === 1) { this.laser(true); this.st_t = 3.2; }
          else if (s === 2) { this.sweep(0); this.st_t = 2.6; }
          else if (s === 3) { this.bolts(4); this.st_t = 3.2; }
          else { this.laser(false); this.summon(); this.st_t = 3.2; }
        } else {
          const s = k % 5;
          if (s === 0) { this.slam(0); this.slam(1, 0.4); this.st_t = 2.0; }
          else if (s === 1) { this.laser(true); this.rain(5); this.st_t = 2.6; }
          else if (s === 2) { this.sweep(0); this.bolts(3); this.st_t = 2.6; }
          else if (s === 3) { this.laser(false); this.slam(1); this.st_t = 2.6; }
          else { this.rain(7); this.bolts(5); this.st_t = 2.8; }
        }
      }
    }
    rain(n) { const slots = [...Array(9).keys()].sort(() => Math.random() - 0.5).slice(0, n); for (const s of slots) this.marks.push({ x: 30 + s * 30, t: 0.8 }); G.audio.sfx('warn'); }
    summon() {
      const L = this.L;
      if (L.ents.filter((e) => !e.dead && !e.isBoss).length >= 2) return;
      for (const x of [70, 200]) { const e = new G.Enemies.Bug(L, x, 30, true); e.vy = 0; L.ents.push(e); L.ring(x + 8, 40, 2, 14, '#3cff7a', 0.3); }
    }
    draw(g, cx, cy) {
      const bx = Math.round(this.x) - cx - 2, by = Math.round(this.y) - cy - 20, shake = this.dying ? Math.round(Math.sin(this.t * 60) * 1.5) : 0;
      g.drawImage(this.flash > 0 ? G.tint(monoSpr, '#d6ffe0') : monoSpr, bx + shake, by);
      if (this.crack) { g.fillStyle = '#3cff7a'; const pts = [[20, 20, 28, 34], [28, 34, 22, 48], [50, 96, 44, 112], [44, 112, 52, 128]]; for (let i = 0; i < (this.crack > 1 ? 4 : 2); i++) G.line(g, bx + pts[i][0] + shake, by + pts[i][1], bx + pts[i][2] + shake, by + pts[i][3], this.crack > 1 ? '#ff5d5d' : '#3cff7a'); }
      // the eye
      const ex = this.ex - cx + shake, ey = this.ey - cy, o = this.open;
      if (o > 0.08) {
        const hgt = Math.round(14 * o);
        g.fillStyle = '#eafff0'; for (let y = -hgt; y <= hgt; y++) { const hw = Math.floor(Math.sqrt(Math.max(0, 15 * 15 - y * y * (15 / Math.max(1, hgt)) * (15 / Math.max(1, hgt))))); g.fillRect(ex - hw, ey + y, hw * 2 + 1, 1); }
        const col = this.phase === 3 ? '#ff4b3e' : '#3cff7a';
        if (hgt > 5) { G.disc(g, ex + this.look.x, ey + this.look.y, 6, col); G.disc(g, ex + this.look.x, ey + this.look.y, 3, K); g.fillStyle = '#fff'; g.fillRect(Math.round(ex + this.look.x) - 3, Math.round(ey + this.look.y) - 3, 2, 2); }
        G.light(ex, ey, 70, col, 1, 0.4);
      } else { g.fillStyle = '#3a3f4c'; g.fillRect(ex - 14, ey, 29, 1); g.fillStyle = '#1f7a3a'; g.fillRect(ex - 10, ey + 1, 21, 1); }
      if (this.boltN > 0 || (this.beam && !this.beam.on)) G.ring(g, ex, ey, 18 + Math.sin(this.t * 30) * 2, C.hazardHi);
      // beam
      if (this.beam) {
        const b = this.beam, y = Math.round(b.y) - cy, x1 = bx + 6;
        if (b.on) { g.fillStyle = '#ffd0d6'; g.fillRect(16 - cx, y - 4, x1 - 16 + cx, 8); g.fillStyle = '#fff'; g.fillRect(16 - cx, y - 2, x1 - 16 + cx, 4); g.fillStyle = C.hazard; g.fillRect(16 - cx, y - 5, x1 - 16 + cx, 1); g.fillRect(16 - cx, y + 4, x1 - 16 + cx, 1); for (let x = 40; x < x1; x += 50) G.light(x, y, 50, '#ff4f6d', 1, 0.5); }
        else { g.fillStyle = ((this.t * 16) | 0) % 2 ? C.hazard : C.hazardHi; for (let x = 18; x < x1; x += 8) g.fillRect(x - cx, y, 4, 1); G.text(G.ug, '!', 22, y - 4, C.hazardHi, { outline: K }); }
        g.fillStyle = C.hazard; g.fillRect(x1 - 2, y - 5, 6, 10);
      }
      for (const m of this.marks) this.warnCol(g, m.x, cx, cy, this.t);
      for (const f of this.fists) {
        const x = Math.round(f.x) - cx, y = Math.round(f.y) - cy;
        if (f.st === 'track' || f.st === 'hang') { g.fillStyle = 'rgba(0,0,0,0.35)'; g.fillRect(x - 11, FLOOR - 2 - cy, 22, 2); g.fillStyle = ((this.t * 14) | 0) % 2 ? C.hazard : C.hazardHi; g.fillRect(x - 11, FLOOR - cy, 22, 1); }
        if (f.st === 'sweepPrep') { g.fillStyle = ((this.t * 14) | 0) % 2 ? C.hazard : C.hazardHi; for (let xx = 50; xx < 290; xx += 8) g.fillRect(xx - cx, FLOOR - 12 - cy, 4, 1); }
        g.drawImage(fistSpr, x - 14, y - 13);
      }
    }
  }

  G.Bosses = { null: Null, merge: Merge, leak: Leak, loop: Loop, mono: Monolith };
})();

